export function bytesToSize(bytes, decimals = 2) {
    if (bytes === 0) return '0 Bytes';
  
    const k = 1024;
    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
  
    // Calculate the size in the appropriate unit
    const size = parseInt((bytes / Math.pow(k, i)).toFixed(decimals));
    
    // Return the formatted string with the unit
    return `${size} ${sizes[i]}`;
  }